import { useTranslation } from "react-i18next";
import CompareStripedRows from "./CompareStripedRows";
import { V1Clinic } from "../../types/v1_schemas";
import { getLookupOptions } from "../../types/lookup";

function SubstanceUseServicesTable({
  providerA,
  providerB,
}: {
  providerA: V1Clinic;
  providerB: V1Clinic;
}) {
  const { t } = useTranslation();

  if (!providerA.clinicServicesProvideds?.filter(f => 
    f.serviceCategoryText === t("substanceUseServices")) 
    && !providerB.clinicServicesProvideds?.filter(f => 
      f.serviceCategoryText === t("substanceUseServices"))) {
    return <></>;
  }

  const rowData = getLookupOptions("servicesProvided").filter((x) => x.description === "1500101").map((service) => {
    return {
      label: t(service.translate),
      compareA: !!providerA.clinicServicesProvideds?.filter(f => 
        f.serviceCategoryText === t("substanceUseServices") 
        && t(f.serviceProvidedText!) === t(service.translate)
      )[0],
      compareB: !!providerB.clinicServicesProvideds?.filter(f => 
        f.serviceCategoryText === t("substanceUseServices") 
        && t(f.serviceProvidedText!) === t(service.translate)
      )[0]
    };
  });

  return (
    <CompareStripedRows rows={rowData} title={t("substanceUseServices")} />
  );
}

export default SubstanceUseServicesTable;
